import './SearchInput.css';
import React, { Component } from 'react';

import { Select } from 'antd';
import { Translate } from 'react-localize-redux';
const Option = Select.Option;

export default class SearchInput extends Component {
  render() {
    const { data } = this.props;
    return (
      <div className="col-12 col-sm-6">
        <label>
          <Translate id={this.props.label} />
        </label>

        <Select
          onChange={this.props.onChange}
          disabled={this.props.disabled}
          className="k-dropdown"
          value={this.props.value}
          getPopupContainer={() => document.getElementById('root')}
        >
          {data ? (
            data
              .sort((a, b) =>
                a.name.localeCompare(b.name, undefined, { numeric: true })
              )
              .map(d => <Option key={d.code}>{d.name}</Option>)
          ) : (
            <Option key="loading">Loading</Option>
          )}
        </Select>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/SearchInput.js